import type { ComponentType, ReactNode } from 'react';
import { Group, Text } from '@mantine/core';

import type { FigmaIconProps } from '@/assets/icons';
import {
  IconFigmaAlertTriangle,
  IconFigmaCheckCircle,
  IconFigmaWarningTriangle
} from '@/assets/icons';

export type ToastTone = 'success' | 'warning' | 'danger';

const toastConfig: Record<ToastTone, { icon: ComponentType<FigmaIconProps>; color: string }> = {
  success: { icon: IconFigmaCheckCircle, color: 'var(--color-status-success)' },
  warning: { icon: IconFigmaWarningTriangle, color: 'var(--color-status-warning)' },
  danger: { icon: IconFigmaAlertTriangle, color: 'var(--color-status-danger)' }
};

interface ToastProps {
  tone?: ToastTone;
  children: ReactNode;
}

export const Toast = ({ tone = 'success', children }: ToastProps) => {
  const { icon: Icon, color } = toastConfig[tone];

  return (
    <Group
      gap={10}
      wrap="nowrap"
      align="flex-start"
      px={14}
      py={12}
      style={{
        width: '100%',
        borderRadius: 8,
        border: `1px solid ${color}`,
        backgroundColor: `var(--color-status-${tone}-soft)`
      }}
    >
      <Icon size={16} color={color} />
      <Text fz={13} style={{ color }}>
        {children}
      </Text>
    </Group>
  );
};
